export enum UserRole {
  student = 'aluno',
  teacher = 'servidor',
}
